import React from "react";
import { Link } from 'react-router-dom';
import "./footer.css";
import { Container, Row, Col, Nav, NavItem } from "reactstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import logoFooter from "../../assets/images/logoNb.png";

function Footer() {
  return (
    <Row className="bg-dark p-4">
      <Container>
        <Row>
          <Col>
            <img src={logoFooter} className="logo m-auto" alt="logo NSC Escola"/>
          </Col>
          <Col md="12">
            <Nav className="d-flex justify-content-center display-none-mobile">
              <NavItem>
                <Link className="anchor nav-link" to="linguagens"><b>LIT</b></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to="matematica"><b>MTT</b></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to="/ciencias"><b>CNT</b></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to="/ciencias-humanas-e-sociais"><b>CHSA</b></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to="/formacao-tecnica-profissional"><b>FTP</b></Link>
              </NavItem>
            </Nav>
          </Col>         
        </Row>
        <Row>
          <Col>
            <Nav className="d-flex justify-content-center">
              <NavItem>
                <Link className="anchor nav-link" to=""><FontAwesomeIcon icon={faTwitter} size="lg"/></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to=""><FontAwesomeIcon icon={faFacebookF} size="lg"/></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to=""><FontAwesomeIcon icon={faYoutube} size="lg"/></Link>
              </NavItem>
              <NavItem>
                <Link className="anchor nav-link" to=""><FontAwesomeIcon icon={faInstagram} size="lg"/></Link>
              </NavItem>
            </Nav>
          </Col>
          <Col xs="12" md="12" lg="12" xl="12" className="text-center">
            © Copyright 2020 NSC Comunicação - Todos os direitos reservados.
        </Col>
        </Row>
      </Container>
    </Row>
  );
}

export default Footer;